// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","745":"component---src-pages-privacy-js"}[chunkId] || chunkId) + "-" + {"293":"c59343bb488431843077","510":"670cc6628db8629bf8ea","522":"634e12a74372e6c75f7e","745":"15a8c1a13bb52ad93c23"}[chunkId] + ".js";
};